var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-contact-table',{attrs:{"config-file-name":"contact_for_club","select-config-name":['default'],"config-file-name-for-export":'contact_for_club'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }